import React from 'react'
import { Link } from 'react-router-dom'
import Logo from '../../images/logoMain.png';


function FooterThree() {
  return (
	
      <footer>
        <div className="footer-top footer-bg third-footer-bg">
          <div className="container custom-container">
            <div className="row justify-content-between">
              <div className="col-lg-6">
                <div className="footer-widget mb-50">
                  <div className="logo mb-35">
                    <Link to="/"><img src={Logo} alt="" style={{'width': '350px'}} /></Link>
                  </div>
                  <div className="fw-text">
                    <p>MetaSocial: The Next ingenious Utility Innovation in the Blockchain World
The open social network made for creators | Engage 2 Earn | Explore clubs and VR digital cities | 〄 $CIP 〄</p>
                    <div className="fw-social">
                      <ul>
                        <li><a href="https://t.me/cipherem" target = "__blank"><i className="fab fa-telegram" /></a></li>
                        <li><a href="https://twitter.com/cipherem" target = "__blank"><i className="fab fa-twitter" /></a></li>
                        <li><a href="https://medium.com/@press_62958" target = "__blank"><i className="fab fa-medium" /></a></li>
                        <li><a href="https://youtube.com/channel/UCjzo5bbhBfj7BWmTtWBjqkQ" target = "__blank"><i className="fab fa-youtube" /></a></li>
                        <li><a href="https://www.linkedin.com/company/cipherem" target = "__blank"><i className="fab fa-linkedin" /></a></li>

                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-2 col-lg-3 col-md-5">
                <div className="footer-widget text-right mb-50">
                  <div className="fw-title mb-35">
                    <h3>Quick Link</h3>
                  </div>
                  <div className="fw-quick-link">
                    <ul>
                      <li><a href="/#">About Us</a></li>
                      <li><a href="/#">Gitbook</a></li>
                      <li><a href="/#">Exchange</a></li>
                      <li><a href="/#">Team</a></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="copyright-wrap third-copyright-wrap" style={{'backgroundColor': 'black'}}>
          <div className="container custom-container">
            <div className="row">
              <div className="col-lg-6 col-md-6">
                <div className="copyright-text">
                  <p>Copyright © 2022 <Link to="/">CIPHEREM</Link> All Rights Reserved.</p>
                </div>
              </div>
              <div className="col-lg-6 col-md-6 d-none d-md-block">
                <div className="payment-method-img text-right">
                  {/* <img src="assets/img/images/card_img.png" alt="img" /> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
  )
}

export default FooterThree